module.exports = __webpack_public_path__ + "static/media/land-definition-bg-1.0c2f990e.png";